import React, { Fragment } from "react";
import { Box, Button, Dialog, DialogContent, DialogTitle, IconButton } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import CloudUploadOutlinedIcon from "@material-ui/icons/CloudUploadOutlined";
import RemoveCircleOutlineOutlinedIcon from "@material-ui/icons/RemoveCircleOutlineOutlined";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import CloseIcon from "@material-ui/icons/Close";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import ImageIcon from "@material-ui/icons/Image";
import { FormStore, FORM_STATUS } from "../../services/form.store";
import {
  messages,
  GeneralConfig,
  IS_HELP_MEDIA_UPLOAD_ENABLED,
} from "../../utility/Constant";
import FormBuilderService from "../../services/form-builder.service";
import { toast } from "react-toastify";
import _ from "lodash";
import { Loader } from "../Loader";
import AlertDialog from "./AlertDialog";
import { ALERT_DIALOGS } from "../../services/form.helper.service";

const styles = (theme) => ({
  thumbnailGroup: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-start",
    position: "relative",
    marginTop: "20px",
  },
  thumbnailInner: {
    display: "inline-block",
    width: "190px",
    paddingBottom: "7px",
    marginRight: "20px",
    position: "relative",
  },
  errorExcessImagesUpload: {
    width: "100%",
    marginTop: "12px",
  },
  
  error: {
    color: "red",
    padding: "4px",
    fontSize: 14,
    width: "-webkit-fill-available",
  },
  UploadButton: {
    display: "none",
  },
  helpUploadButton: {
    color: "#757a76",
    border: "1px solid gray",
  },
  removeImageIcon: {
    position: "absolute",
    top: "-6px",
    right: "-6px",
    zIndex: 2,
    color: "red",
    backgroundColor: "white",
    borderRadius: "50%",
    cursor: "pointer",
  },
  loaderBoxMainGroup: {
    width: "190px",
    height: "120px",
    position: "relative",
    marginRight: "10px",
  },
  loaderBoxGroup: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  loaderBox: {
    "& > .MuiCircularProgress-root": {
      width: "20px !important",
      height: "20px !important",
    },
  },

  imageThumbnailWrapper: {
    position: "relative",
    width: "190px",
    height: "120px",
    borderRadius: "2px",
    overflow: "hidden",
  },
  imageBadge: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: "rgba(255,255,255,0.85)",
    fontSize: "40px",
    zIndex: 4,
    pointerEvents: "none",
    filter: "drop-shadow(0px 1px 4px rgba(0,0,0,0.6))",
  },
  imageThumbnailFrame: {
    display: "block",
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  uploadHint: {
    color: "#696868",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
    alignSelf: "center",
    marginLeft: "12px",
  },
  uploadRow: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    marginTop: "10px",
  },
  pdfThumbnailWrapper: {
    width: "190px",
    height: "120px",
    overflow: "hidden",
    position: "relative",
    borderRadius: "2px",
    backgroundColor: "#fff",
    "&:hover $pdfNameOverlay": {
      opacity: 1,
    },
  },
  pdfBadge: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: "#b71c1c",
    fontSize: "40px",
    zIndex: 4,
    pointerEvents: "none",
    filter: "drop-shadow(0px 1px 3px rgba(0,0,0,0.25))",
  },
  pdfNameOverlay: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    background: "rgba(0,0,0,0.55)",
    color: "#fff",
    fontSize: "11px",
    padding: "4px 6px",
    opacity: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    zIndex: 3,
    pointerEvents: "none",
  },
  pdfThumbnailFrame: {
    width: "800px",
    height: "505px",
    transform: "scale(0.2375)",
    transformOrigin: "0 0",
    pointerEvents: "none",
    border: "none",
    outline: "none",
    display: "block",
  },
  videoThumbnailWrapper: {
    width: "190px",
    height: "120px",
    overflow: "hidden",
    position: "relative",
    borderRadius: "2px",
    backgroundColor: "#000",
    "&:hover $pdfNameOverlay": {
      opacity: 1,
    },
  },
  videoThumbnailFrame: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    pointerEvents: "none",
    display: "block",
  },
  videoPlayOverlay: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: "rgba(255,255,255,0.85)",
    fontSize: "40px",
    zIndex: 4,
    pointerEvents: "none",
    filter: "drop-shadow(0px 1px 4px rgba(0,0,0,0.6))",
  },
});

class HelpImagesGroup extends React.Component {
  constructor(props) {
    super();
    this.FormBuilderService = new FormBuilderService();
    const images = props?.propsimagesData && !props.propsimagesData.includes(null)
      ? props.propsimagesData.map((f) => ({ ...f, imageUrl: "", fileType: f.fileType || "image" }))
      : [];
    const legacyPdfs = props?.propsPdfsData && !props.propsPdfsData.includes(null)
      ? props.propsPdfsData.map((f) => ({
          imageName: f.pdfName,
          imageId: f.pdfId,
          imageUrl: "",
          fileType: "pdf",
        }))
      : [];
    const allFiles = [...images, ...legacyPdfs];
    this.state = {
      files: allFiles,
      isLoading: false,
      isLoadingForFiles: allFiles.length > 0,
      showDeleteConfirmDialog: false,
      fileDeleteId: null,
      isDeleting: false,
      previewFile: null,
    };

    if (allFiles.length > 0) {
      this.getFormFiles();
    }
  }

  openPreview = (url, name, type) => {
    this.setState({ previewFile: { url, name, type } });
  };

  closePreview = () => {
    this.setState({ previewFile: null });
  };

  uploadFile = (e) => {
    const originalFileObj = e?.target?.files?.[0];
    if (!originalFileObj) return;
    if (this.state.files.length >= GeneralConfig.MAX_IMAGE_COUNT) {
      toast.error(messages.CANNOT_UPLOAD_MORE_IMAGES);
      return;
    }
    if (originalFileObj.size > GeneralConfig.MAX_FILE_SIZE_BYTES) {
      toast.error(messages.FILE_SIZE_ERROR);
      return;
    }
    const isPdf = originalFileObj.type === "application/pdf";
    const isVideo = originalFileObj.type.startsWith("video/");
    const isImage = originalFileObj.type === "image/png" || originalFileObj.type === "image/jpeg";
    if (IS_HELP_MEDIA_UPLOAD_ENABLED && !isImage && !isPdf && !isVideo) {
      toast.error(messages.FILE_TYPE_ERROR);
      return;
    }
    if (!IS_HELP_MEDIA_UPLOAD_ENABLED && !isImage) {
      toast.error(messages.FILE_TYPE_ERROR);
      return;
    }
    const mimeType = originalFileObj.type;
    const splitExtension = originalFileObj.name.split(/\.(?=[^.]+$)/);
    const newFileName =
      splitExtension[0].replace(/[\W_]/g, "_") + "." + splitExtension[1];
    const blob = new Blob([originalFileObj], { type: mimeType });
    const file = new File([blob], newFileName, {
      type: mimeType,
      lastModified: originalFileObj.lastModified,
    });
    const fileName = file.name;
    const label = isPdf ? "PDF" : isVideo ? "Video" : "Image";
    if (_.filter(this.state.files, (f) => f.imageName === fileName).length > 0) {
      toast.error(`${label} ${originalFileObj.name} already exists.`);
    } else {
      const id = this.generateFileId();
      const fileObj = {
        imageName: fileName,
        imageUrl: (isPdf || isVideo) ? "" : URL.createObjectURL(file),
        imageId: id,
        file,
        fileType: isPdf ? "pdf" : isVideo ? "video" : "image",
      };
      this.setState({ isLoading: true });
      this.FormBuilderService.uploadImageDetails(fileObj).then((response) => {
        this.setState({ isLoading: false });
        if (!response) {
          toast.error(
            ALERT_DIALOGS.ADD_UNDEFINED_ERROR_MESSAGE,
          );
        } else {
          fileObj.imageUrl = response?.attachments?.[0]?.file || "";
          delete fileObj.file;
          FormStore.sharedInstance().addHelpImage(fileObj);
          this.setState((prevState) => ({
            files: [...prevState.files.filter((f) => f.imageId !== fileObj.imageId), fileObj],
          }));
          toast.success(
            isPdf
              ? ALERT_DIALOGS.ADD_PDF_SUCCESS_MESSAGE
              : isVideo
              ? ALERT_DIALOGS.ADD_VIDEO_SUCCESS_MESSAGE
              : ALERT_DIALOGS.ADD_IMAGE_SUCCESS_MESSAGE,
          );
        }
      }).catch(() => {
        this.setState({ isLoading: false });
        toast.error(messages.ERROR_MESSAGE);
      });
    }
  };

  getFormFiles = () => {
    this.state.files.forEach(async (val) => {
      await this.FormBuilderService.imageDetails(val.imageId, GeneralConfig.GET)
        .then(this.setState({ isLoadingForFiles: true }))
        .then((response) => {
          val.imageUrl = response?.attachments?.[0]?.file || "";
          this.setState({ isLoadingForFiles: false });
        });
    });
  };

  generateFileId() {
    return (
      (this.props?.elementHasId !== undefined
        ? this.props?.elementHasId
        : new Date().getFullYear()) +
      "-" +
      Date.now() +
      "-" +
      this.state.files.length
    );
  }

  confirmDelete = (fileId) => {
    this.setState({ showDeleteConfirmDialog: true, fileDeleteId: fileId });
  };

  handleCancelDelete = () => {
    this.setState({ showDeleteConfirmDialog: false });
  };

  handleConfirmDelete = () => {
    this.removeFile(this.state.fileDeleteId);
  };

  removeFile = (id) => {
    const isPdf = this.state.files.find((f) => f.imageId === id)?.fileType === "pdf";
    const isVideo = this.state.files.find((f) => f.imageId === id)?.fileType === "video";
    this.setState({ isDeleting: true });
    return this.FormBuilderService.imageDetails(id, GeneralConfig.DELETE)
      .then((response) => {
        if (response && response.status && response.status === 200) {
          let allFiles = FormStore.sharedInstance().removeHelpImage(
            response.data.imageId,
          );
          toast.success(isPdf ? ALERT_DIALOGS.DELETE_PDF_SUCCESS_MESSAGE : isVideo ? ALERT_DIALOGS.DELETE_VIDEO_SUCCESS_MESSAGE : ALERT_DIALOGS.DELETE_IMAGE_SUCCESS_MESSAGE);
          this.setState({ files: allFiles });
        } else {
          toast.error(isPdf ? ALERT_DIALOGS.DELETE_PDF_ERROR_MESSAGE : isVideo ? ALERT_DIALOGS.DELETE_VIDEO_ERROR_MESSAGE : ALERT_DIALOGS.DELETE_IMAGE_ERROR_MESSAGE);
        }
      })
      .then(() => {
        this.setState({
          fileDeleteId: null,
          showDeleteConfirmDialog: false,
          isDeleting: false,
        });
        FormStore.sharedInstance().SaveAsDraft(FORM_STATUS.DRAFT);
      });
  };

  render() {
    const { classes } = this.props;
    const { files } = this.state;
    const imageFiles = files.filter((f) => (f.fileType || "image") === "image");
    const pdfFiles = IS_HELP_MEDIA_UPLOAD_ENABLED
      ? files.filter((f) => f.fileType === "pdf")
      : [];
    const videoFiles = IS_HELP_MEDIA_UPLOAD_ENABLED
      ? files.filter((f) => f.fileType === "video")
      : [];
    const isOperationInProgress =
      this.state.isLoading ||
      this.state.isDeleting ||
      this.state.isLoadingForFiles;
    return (
      <Fragment>
        <Box className={classes.box} pb={5} pl={3} pr={1}>
          <div className={classes.thumbnailGroup}>
            {imageFiles.map((item, index) =>
                item ? (
                  item?.imageUrl ? (
                    <div className={classes.thumbnailInner} key={index}>
                      <RemoveCircleOutlineOutlinedIcon
                        className={classes.removeImageIcon}
                        id="helpDeleteImageButton"
                        onClick={() => this.confirmDelete(item.imageId)}
                      />
                      <div
                        className={classes.imageThumbnailWrapper}
                        onClick={() => this.openPreview(item.imageUrl, item.imageName, "image")}
                        style={{ cursor: "pointer" }}
                        title={item.imageName}
                      >
                        <ImageIcon className={classes.imageBadge} />
                        <img
                          src={item?.imageUrl}
                          alt={`Help-${item.imageId}`}
                          className={classes.imageThumbnailFrame}
                        />
                      </div>
                    </div>
                  ) : this.state.isLoadingForFiles ? (
                    <RenderSpinner
                      loading={this.state.isLoadingForFiles}
                      classes={classes}
                    />
                  ) : null
                ) : null,
              )}
              {pdfFiles.map((pdf, index) =>
                pdf.imageUrl ? (
                  <div className={classes.thumbnailInner} key={`pdf-${index}`}>
                    <RemoveCircleOutlineOutlinedIcon
                      className={classes.removeImageIcon}
                      id="helpDeletePdfButton"
                      onClick={() => this.confirmDelete(pdf.imageId)}
                    />
                    <div
                      className={classes.pdfThumbnailWrapper}
                      onClick={() => this.openPreview(pdf.imageUrl, pdf.imageName, "pdf")}
                      style={{ cursor: "pointer" }}
                      title={pdf.imageName}
                    >
                      <PictureAsPdfIcon className={classes.pdfBadge} />
                      <iframe
                        src={`${pdf.imageUrl}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
                        title={pdf.imageName}
                        className={classes.pdfThumbnailFrame}
                        scrolling="no"
                      />
                      <span className={classes.pdfNameOverlay}>{pdf.imageName}</span>
                    </div>
                  </div>
                ) : this.state.isLoadingForFiles ? (
                  <RenderSpinner
                    key={`pdf-spinner-${index}`}
                    loading={this.state.isLoadingForFiles}
                    classes={classes}
                  />
                ) : null,
              )}
            {videoFiles.map((vid, index) =>
                vid.imageUrl ? (
                  <div className={classes.thumbnailInner} key={`vid-${index}`}>
                    <RemoveCircleOutlineOutlinedIcon
                      className={classes.removeImageIcon}
                      id="helpDeleteVideoButton"
                      onClick={() => this.confirmDelete(vid.imageId)}
                    />
                    <div
                      className={classes.videoThumbnailWrapper}
                      onClick={() => this.openPreview(vid.imageUrl, vid.imageName, "video")}
                      style={{ cursor: "pointer" }}
                      title={vid.imageName}
                    >
                      <PlayCircleOutlineIcon className={classes.videoPlayOverlay} />
                      <video
                        src={vid.imageUrl}
                        className={classes.videoThumbnailFrame}
                        muted
                        preload="metadata"
                      />
                      <span className={classes.pdfNameOverlay}>{vid.imageName}</span>
                    </div>
                  </div>
                ) : this.state.isLoadingForFiles ? (
                  <RenderSpinner
                    key={`vid-spinner-${index}`}
                    loading={this.state.isLoadingForFiles}
                    classes={classes}
                  />
                ) : null,
              )}
            {this.state.isLoading ? (
              <RenderSpinner loading={true} classes={classes} />
            ) : null}
          </div>
          
          {files.length >= GeneralConfig.MAX_IMAGE_COUNT ? (
            <div className={classes.errorExcessImagesUpload}>
              <label className={classes.error}>
                {messages.CANNOT_UPLOAD_MORE_IMAGES}
              </label>
            </div>
          ) : null}
          <div className={classes.uploadRow}>
            <input
              accept={IS_HELP_MEDIA_UPLOAD_ENABLED ? ".png,.jpg,.jpeg,.pdf,.mp4" : ".png,.jpg,.jpeg"}
              type="file"
              className={classes.UploadButton}
              id="contained-button-file"
              onChange={this.uploadFile}
              disabled={isOperationInProgress || files.length >= GeneralConfig.MAX_IMAGE_COUNT}
            />
            <label htmlFor="contained-button-file">
              <Button
                variant="contained outlined"
                id="helpUploadFilesButton"
                component="span"
                className={classes.helpUploadButton}
                startIcon={<CloudUploadOutlinedIcon />}
                disabled={isOperationInProgress || files.length >= GeneralConfig.MAX_IMAGE_COUNT}
              >
                Upload Files
              </Button>
            </label>
            <span className={classes.uploadHint}>
              {IS_HELP_MEDIA_UPLOAD_ENABLED
                ? messages.UPLOAD_HINT
                : messages.UPLOAD_HINT_IMAGE_ONLY}
            </span>
          </div>
        </Box>
        {this.state.showDeleteConfirmDialog ? (
          <AlertDialog
            open={this.state.showDeleteConfirmDialog}
            onClose={this.handleCancelDelete}
            handleOk={this.handleConfirmDelete}
            dialogTitle={ALERT_DIALOGS.DELETE_FORM_TITLE}
            dialogContent={ALERT_DIALOGS.DELETE_IMAGE_CONTENT}
            cancelButton={ALERT_DIALOGS.DELETE_FORM_CANCEL}
            confirmButton={ALERT_DIALOGS.DELETE_FORM_CONFIRM}
          />
        ) : null}
        {this.state.previewFile ? (
          <Dialog
            open={!!this.state.previewFile}
            onClose={this.closePreview}
            maxWidth={this.state.previewFile.type === "pdf" ? "lg" : "md"}
            fullWidth
          >
            <DialogTitle disableTypography style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <span style={{ fontFamily: "Roboto", fontSize: "16px", fontWeight: 500 }}>
                {this.state.previewFile.name}
              </span>
              <IconButton size="small" onClick={this.closePreview}>
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent style={{ padding: this.state.previewFile.type === "image" ? "0 0 16px" : "0", display: "flex", justifyContent: "center", backgroundColor: this.state.previewFile.type === "image" ? "#000" : undefined }}>
              {this.state.previewFile.type === "video" && (
                <video
                  src={this.state.previewFile.url}
                  controls
                  autoPlay
                  style={{ width: "100%", maxHeight: "70vh", display: "block" }}
                />
              )}
              {this.state.previewFile.type === "image" && (
                <img
                  src={this.state.previewFile.url}
                  alt={this.state.previewFile.name}
                  style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain", display: "block" }}
                />
              )}
              {this.state.previewFile.type === "pdf" && (
                <iframe
                  src={this.state.previewFile.url}
                  title={this.state.previewFile.name}
                  style={{ width: "100%", height: "80vh", border: "none", display: "block" }}
                />
              )}
            </DialogContent>
          </Dialog>
        ) : null}

      </Fragment>
    );
  }
}

function RenderSpinner(props) {
  return (
    <div className={props.classes.loaderBoxMainGroup}>
      <div className={props.classes.loaderBoxGroup}>
        <div className={props.classes.loaderBox}>
          <Loader position="center" loading={props.loading} />
        </div>
      </div>
    </div>
  );
}
export default withStyles(styles)(HelpImagesGroup);
